import React from 'react'

const Header = () => {
   
    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        <h5 style={{fontFamily: 'Urbanist'}}>CHO - DANTZIG MIN MAX</h5>
                    </div>
                </nav>
            </header>
        </>
    )
}

export default Header